import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  getOverChargeClaimDetailsInSuccess,
  setOverChargeClaimEditActiveKey,
  setOverChargeClaimsEditDrawer,
} from '../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { setPageBlocker } from '../../../../../../../redux/common/CommonActions';
import PrimaryLabel from '../../../../../../components/Labels/PrimaryLabel';
import Drawer from '../../../../../../components/Modals/Drawer';
import ContentSpinner from '../../../../../../components/Spinners/ContentSpinner';
import OverChargeEditTabs from '../Tabs/OverChargeEditTabs';
import OverChargeDrawerHeader from './OverChargeDrawerHeader';

const OverChargeEditDrawer = () => {
  const dispatch = useDispatch();
  const { editDrawer, claimDetails, editTabKey } = useSelector((state) => state.overChargeClaims);
  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      dispatch(setPageBlocker(false));
      dispatch(getOverChargeClaimDetailsInSuccess({ data: {}, success: false }));
    }
  };

  const handleTabChange = (key) => dispatch(setOverChargeClaimEditActiveKey(key));

  return (
    <Drawer
      visible={editDrawer}
      onClose={() => dispatch(setOverChargeClaimsEditDrawer(false))}
      headerContents={
        <OverChargeDrawerHeader
          claimNo={claimDetails?.data?.customerClaimNo}
          currency={claimDetails?.data?.currencyCode}
        />
      }
      width="85%"
      afterOpenChange={handleOpenChange}
      destroyOnClose
    >
      {claimDetails?.progressing ? (
        <div className="p-30 vh-90">
          <ContentSpinner size="large" />
        </div>
      ) : (
        <>
          {claimDetails?.success ? (
            <OverChargeEditTabs handleTabChange={handleTabChange} activeKey={editTabKey} />
          ) : (
            <Row justify="center" align="middle" className="h-100">
              <Col>
                <PrimaryLabel className="text-danger f-25">{claimDetails?.message}</PrimaryLabel>
              </Col>
            </Row>
          )}
        </>
      )}
    </Drawer>
  );
};

export default OverChargeEditDrawer;
